// Utils/Notification.js

// Ask permission once
export const askNotificationPermission = async () => {
  if (Notification.permission !== 'granted') {
    const permission = await Notification.requestPermission();
  }
};

// Function to send a Windows notification
export const sendNotification = (title, body) => {
  if (Notification.permission === 'granted') {
    new Notification(title, { body });
  } else {
    console.error("Notification permission not granted.");
  }
};
